/* eslint-disable react/display-name */
import React, { memo, useEffect, useMemo } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { withScreenSize } from '../common/utilities/withScreenSize.jsx';
import { reduxConnect } from '../../common';
import { LifeStories } from '../common/life/lifeStories.js';
import { LifePageContentTitle } from '../common/life/lifePageContentTitle';
import { LifeIntroText } from '../common/life/lifeIntroText';
import { DisplayAdWidget } from '../ads/displayAdWidget.jsx';
import { mediumMediaQuery, largeMediaQuery } from '../../common/utilities/sizeHelpers';
import { translate } from  '../../common/translation/translate.js';
import { getNewsStories } from '../../common/actions/stories/storiesAction';
import { DisplayAdUnit } from '../../containers/ads/displayAdUnitContainer';

const mapStoreStateToProps = storeState => {
    const { newsStories } =  storeState;
    const appState = storeState.appState.appState || {};
    const { enableSourceParameterOnStoriesLinks } = appState;

    return {
        coldAndFluStories: newsStories?.stories,
        enableSourceParameterOnStoriesLinks
    };
};

const mapDispatchToProps = {
    getNewsStories
};

const source = 'life/cold-flu';

const ColdFluPage =  withScreenSize(reduxConnect( mapStoreStateToProps, mapDispatchToProps ) (memo(({
    coldAndFluStories,
    enableSourceParameterOnStoriesLinks,
    getNewsStories,
    isDesktop,
    isMobile
}) => {
    const { mainStory, subStoriesList } = useMemo(() => {
        const [mainStory, ...restSubStoriesList] = coldAndFluStories; 
        return { 
            mainStory, 
            subStoriesList: restSubStoriesList 
        }; 
    },
    [
        coldAndFluStories?.length,
        coldAndFluStories?.[0]?.Id,
        coldAndFluStories?.[1]?.Id,
        coldAndFluStories?.[2]?.Id,
        coldAndFluStories?.[3]?.Id,
        coldAndFluStories?.[4]?.Id
    ]);

    useEffect(() => {
        window.scrollTo(0, 0);
        getNewsStories({ baseUrl: location.origin, category: 'Cold-and-Flu', count: 6 });
    }, []);

    return (
        <>
            {!isDesktop
                && <MobileBannerAd>
                    <DisplayAdUnit
                        width={320}
                        height={50}
                        slotId={'life_coldflu_mobile_top_banner_x83'}
                    />
                </MobileBannerAd>
            }
            <LifePageContentTitle pageTitle={translate('coldAndFlu')} showTitleAsH1={true} />
            <LifeIntroText>{translate('coldFluIntro')}</LifeIntroText>
            <PageContainer>
                <StoriesContainer>
                    <LifeStories
                        mainStory={mainStory}
                        subStoriesList={subStoriesList}
                        slotId={'life_coldflu_mobile_stories_x11'}
                        isMobile={isMobile}
                        enableSourceParameterOnStoriesLinks={enableSourceParameterOnStoriesLinks}
                        source={source}
                    />
                </StoriesContainer>
                {isDesktop
                    && <AdContainer>
                        <DisplayAdUnit
                            slotId={'life_coldflu_top_right_x16'}
                            height={600}
                            width={300}
                        />
                    </AdContainer>
                }
            </PageContainer>
        </>
    );
})));

ColdFluPage.displayName = 'ColdFluPage';
ColdFluPage.propTypes = {
    coldAndFluStories: PropTypes.array,
    getNewsStories: PropTypes.func,
    isMobile: PropTypes.bool,
    isDesktop: PropTypes.bool
};

const MobileBannerAd = styled.div`
    margin-bottom: 20px;
`;

const PageContainer = styled.div`
    display: flex;
    flex-direction: row;
    @media ${largeMediaQuery} {
        margin-right: 5px;
    }
`;

const StoriesContainer = styled.div`
    @media ${largeMediaQuery} {
        width: calc(100% - 316px);
    }

    @media ${mediumMediaQuery} {
        margin-bottom: 10px;
    }
`;

const AdContainer = styled.div`
    padding: 10px 0 0 16px;
`;

export { ColdFluPage as default };
